import React, { useMemo } from "react";
import { graphql, useLazyLoadQuery } from "react-relay";
import { WidgetNote } from "widgets";
import { LazyQueryNetworkBoundrary } from "../../../../../components/mobile/QueryNetworkBoundrary";
import { WidgetSizeT } from "../../localTypes/WidgetSizeT";

import { WANoteIntegrationPreviewQuery } from "./__generated__/WANoteIntegrationPreviewQuery.graphql";

type Props = {
  size: WidgetSizeT;
  widgetId: string;
  storecastId: string;
};

export function WAIntegrationNotePreview(props: Props) {
  return (
    <LazyQueryNetworkBoundrary>
      {(fetchKey) => <InnerWAEmaginPreview {...props} fetchKey={fetchKey} />}
    </LazyQueryNetworkBoundrary>
  );
}

function InnerWAEmaginPreview(props: Props & { fetchKey: string }) {
  const data = useLazyLoadQuery<WANoteIntegrationPreviewQuery>(
    graphql`
      query WANoteIntegrationPreviewQuery(
        $storecastId: ID!
        $input: PreviewWidgetNoteIntegrationInput!
      ) {
        dashboard(id: $storecastId) @required(action: THROW) {
          previewWidgetNoteIntegration(input: $input) {
            id
            ...WidgetNote_widgetNote
          }
        }
      }
    `,
    {
      input: {
        size: props.size.h === 1 ? "TWO_X_ONE" : "TWO_X_TWO",
      },
      storecastId: props.storecastId,
    },
    { fetchKey: props.fetchKey, fetchPolicy: "store-and-network" }
  );

  const widget = useMemo(
    () =>
      data.dashboard.previewWidgetNoteIntegration.find(
        (w) => w.id === props.widgetId
      )!,
    [data.dashboard.previewWidgetNoteIntegration, props.widgetId]
  );

  return (
    <WidgetNote
      mode="IDLE"
      widget={widget}
      interactive={false}
      fetchKey={props.fetchKey}
    />
  );
}
